import * as React from 'react'

import { omit } from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { makeLink, parseLocation } from '../../../common/utils/urlHelper'

interface IProps extends React.FormHTMLAttributes<HTMLFormElement> {}

const SearchBarFormPure = (props: IProps & RouteComponentProps<any>) => {
  const { location, history, children } = props
  const passProps = omit(props, [
    'location',
    'router',
    'onSubmit',
    'role',
    'method',
    'action',
    'match',
    'history',
    'staticContext'
  ])

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    // get query from form
    const form = event.currentTarget
    const query: { [propName: string]: string } = {}
    Array.prototype.slice
      .call(form.elements)
      .filter((el: HTMLInputElement) => el.getAttribute('name') && el.value)
      .forEach((el: HTMLInputElement) => {
        query[el.getAttribute('name') as string] = el.value
      })

    // only update query inside the from and keep the existing one
    const nextQuery = { ...parseLocation(location), ...query }

    // remove page param when do search
    delete nextQuery.page

    history.push(makeLink(nextQuery))
  }

  return (
    <form
      role="search"
      method="get"
      action="/search"
      onSubmit={onSubmit}
      {...passProps}
    >
      {children}
    </form>
  )
}

export default withRouter(SearchBarFormPure)



// WEBPACK FOOTER //
// ./client/components/searchBar/searchBarForm.tsx